





















































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, { ALERT_TYPE, VIEW_MODE } from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import { Confirmation, MailQueue } from '@/domain/Confirmation'
import { User } from '@/domain/User'
import { SendMail } from '@/domain/SendMail'
import ConfirmationsService from '@/service/ConfirmationsService'
import NumberIssuingService from '@/service/NumberIssuingService'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    DatePickerComponent,
    PdfViewComponent,
    SendMailDialogComponent,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const confirmationsService = ConfirmationsService.instance
      if (to.params["no"] === undefined) {
        /* 新規 */
        vm.$data.viewMode = VIEW_MODE.NEW
        if (typeof to.query["refs"] === "string") {
          const requestNos = to.query["refs"].split(",")
          confirmationsService.referenceNew(requestNos).then(x => vm.$data.dto = x)
        } else {
          confirmationsService.createNew().then(x => vm.$data.dto = x)
        }
      } else {
        /* 編集 */
        vm.$data.viewMode = VIEW_MODE.VIEW
        confirmationsService.edit(to.params["no"]).then(x => vm.$data.dto = x)
      }
    })
  },
})
export default class MemberConfirmationEdit extends Mixins(GlobalMixin) {
  numberIssuingService = NumberIssuingService.instance
 
  dto = new Confirmation()
  originalDto = this.dto.clone()
  sendMail = new SendMail()

  /* 作成者、承認者リスト */
  users: User[] = []
  authorityUsers: User[] = []

  mounted () {
    this.usersService.findByOccupationCode(1)
      .then((x) => {
        this.users = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.users = []
      })
    this.usersService.findByAuthorityCode(2)
      .then((x) => {
        this.authorityUsers = x
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.authorityUsers = []
      })
  }

  /**
   * 画面を遷移する前のチェック
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    if (!this.isView) {
      this.confirm("このページから移動しますか？入力中のデータは保存されません").then(res => {
        res === true ? next() : next(false)
      })
    } else {
      next()
    }
  }
  
  /**
   * 編集モードに切り替える
   */
  onEdit() {
    if (this.dto.isPrinted || this.dto.isMailSended) {
      this.confirm("既に印刷またはメール送信していますが、本当に編集してよろしいですか？").then(res => {
        if (res === true) {
          this.viewMode = VIEW_MODE.EDIT
        }
      })
    } else {
      this.viewMode = VIEW_MODE.EDIT
    }
    this.originalDto = this.dto.clone()
  }

  /**
   * 削除
   */
  onDelete() {
    this.confirm("本当に削除してよろしいですか？").then(res => {
      if (res === true) {
        this.showLoading()
        this.confirmationsService.delete(this.dto.confirmationNo)
          .then(() => {
            this.viewMode = VIEW_MODE.DELETED
            this.alert("削除しました", ALERT_TYPE.SUCCESS)
            this.hideLoading()
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error)
            this.alert("削除に失敗しました", ALERT_TYPE.ERROR)
            this.hideLoading()
          })
      }
    })
  }

  /**
   * 編集取消
   */
  onReset() {
    this.confirm("本当に編集を取り消してよろしいですか？").then(res => {
      if (res === true) {
        this.dto = this.originalDto
        this.viewMode =  VIEW_MODE.VIEW
      }
    })
  }

  /**
   * 登録ボタンのクリック
   */
  onSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      if (this.viewMode === VIEW_MODE.NEW) {
        /* 登録 */
        this.numberIssuingService.next(NumberIssuingService.CONFIRMATION, this.dto.confirmationOn)
          .then(no => {
            this.dto.confirmationNo = no
            this.save()
          })
          .catch(error => {
            // eslint-disable-next-line
            console.log(error)
          })
      } else {
        /* 更新 */
        if (this.dto.isPrinted || this.dto.isMailSended) {
          this.confirm("印刷およびメール送信情報は、消去されますがよろしいですか？").then(res => {
            if (res === true) {
              this.save()
            } else {
              event.stopPropagation()
            }
          })
        } else {
          this.save()
        }
      }
    } else {
      event.stopPropagation()
    }
  }

  /**
   * 作成者の変更
   */
  onChangeAuthor(event: User) {
    this.dto.authorUser.userId = event.userId
    this.dto.authorUser.userName = event.userName
  }

  /**
   * 承認者の変更
   */
  onChangeAuthorizer(event: User) {
    this.dto.authorizerUser.userId = event.userId
    this.dto.authorizerUser.userName = event.userName
  }

  /**
   * オートコンプリートフィルター
   */
  // eslint-disable-next-line
  usersFilter(item: User, queryText: string, itemText: string) {
    return item.userName.toLowerCase().indexOf(queryText.toLowerCase()) >= 0
  }

  /**
   * 印刷ボタンのクリック
   */
  onPrint() {
    this.confirmationsService.print(this.dto.confirmationNo)
      .then(dto => {
        this.dto = dto
        this.openPdfViewDialog("請書印刷", dto.confirmationFile.content)
      })
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail() {
    this.confirmationsService.generateMailTemplate([this.dto.confirmationNo])
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * データの保存
   */
  private save() {
    this.showLoading()
    this.pdfService.generateConfirmation(this.dto)
      .then(pdf => {
        this.dto.confirmationFile = pdf
        this.dto.printAt = null
        this.dto.mailSendAt = null

        if (this.isNew) {
          this.confirmationsService.create(this.dto)
            .then((x) => {
              this.dto = x
              this.viewMode = VIEW_MODE.VIEW
              this.alert("保存しました", ALERT_TYPE.SUCCESS)
              this.hideLoading()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
              this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
              this.hideLoading()
            })
        } else {
          this.confirmationsService.update(this.dto)
            .then((x) => {
              this.dto = x
              this.viewMode = VIEW_MODE.VIEW
              this.alert("保存しました", ALERT_TYPE.SUCCESS)
              this.hideLoading()
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.log(error)
              this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
              this.hideLoading()
            })
        }
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("保存に失敗しました", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * 初期化処理
   */
  @Watch("dto")
  changeDto() {
    /* 初期化処理 */
    if (this.viewMode === VIEW_MODE.NEW) {
      /* 作成者 */
      const authorUser = this.users.find(x => x.userId === this.loginUserId)
      if (authorUser !== undefined) {
        this.dto.authorUser.userId = authorUser.userId
        this.dto.authorUser.userName = authorUser.userName
      }
    }
  }

  /**
   * 発行日変更時
   */
  @Watch("dto.confirmationOn")
  changeConfirmationOn() {
    this.taxWash()
  }

  /**
   * 消費税率の取得
   */
  private getTaxRate() {
    /* 輸入検査の場合、免税 */
    return this.dto.requestType === 1 ? 0 : this.taxsService.findByActiveTax(this.dto.confirmationOn)
  }

  /**
   * 消費税率の洗い替え
   */
  private taxWash() {
    const taxRate = this.getTaxRate()
    this.dto.details.forEach(x => x.priceInfo.taxRate = taxRate)
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, confirmationNos: [this.dto.confirmationNo]})
    this.confirmationsService.mailQueuePush(mailQueue)
      .then((x) => {
          this.dto.mailSendAt = x.mailSendAt
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 編集
   */
  private edit(confirmationNo: string) {
    /* 編集 */
    this.showLoading()
    this.confirmationsService.edit(confirmationNo)
      .then(x => {
        this.viewMode = VIEW_MODE.VIEW
        this.$router.push(`/member/confirmation/edit/${x.confirmationNo}`)
        this.dto = x
        this.hideLoading()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("データ取得エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }
}
